import { observer } from "mobx-react-lite"
import React, { useContext, useEffect, useState } from 'react'
import { toastError, toastSuccess } from "../../FormComponents/Toasts"
import { ClientSchema } from "../../../schemas/ClientSchema"
import Modal from "../../Modal/Modal"
import EditClientFirstPage from './EditClientParts/EditClientFirstPage'
import EditClientSecondPage from "./EditClientParts/EditClientSecondPage"
import { Formik, Form } from 'formik'
import axiosService from "../../../utils/AxiosService"
import { BrowseContext } from "../../../contexts/BrowseContext"


export default observer(function EditClientModal() {
  const { browseState, selectedClient, openEditClient, clients } = useContext(BrowseContext)
  const [currentPage, setCurrentPage] = useState(browseState.editClientInitialPage)
  const [clientContacts, setClientContacts] = useState([])

  const handleSubmit = (client) => {
    const formData = new FormData()

    formData.append('client[name]', client.name)
    formData.append('client[theme_color]', client.theme_color)
    if (client.image) formData.append('client[image]', client.image)
    client?.collaborators.forEach(collab => formData.append('client[collaborator_ids][]', collab.value))

    if (clientContacts.length !== 0) {
      clientContacts.forEach((contact, index) => {
        if (contact.id) formData.append(`client[client_contacts_attributes][${index}][id]`, contact.id)
        formData.append(`client[client_contacts_attributes][${index}][name]`, contact.name ?? '')
        formData.append(`client[client_contacts_attributes][${index}][email]`, contact.email ?? '')
        formData.append(`client[client_contacts_attributes][${index}][phone]`, contact.phone ?? '')
        formData.append(`client[client_contacts_attributes][${index}][notes]`, contact.notes ?? '')
        if (contact.avatar instanceof File) formData.append(`client[client_contacts_attributes][${index}][avatar]`, contact.avatar)
        if (contact._destroy) formData.append(`client[client_contacts_attributes][${index}][_destroy]`, true)
        })
    }

    axiosService.patch(`/api/project_manager/clients/${selectedClient.id}`, formData, { headers: { "Content-type": "multipart/form-data" } })
      .then((editedClient) => {
        browseState.selectedClient = editedClient
        browseState.toggleEditClient()
        browseState.clients = clients.map(client => client.id === editedClient.id ? editedClient : client)
        toastSuccess(`Client ${editedClient.name} has been updated!`)
      }).catch(({ data: { error } }) => toastError(error))
  }

  const editClientForm = {
    firstPage: EditClientFirstPage,
    secondPage: EditClientSecondPage,
  }

  const PageToRender = editClientForm[currentPage]

  const specificProps = currentPage === 'secondPage' ? {
    clientContacts: clientContacts,
    setClientContacts: setClientContacts,
    setCurrentPage: setCurrentPage,
  } : {}

  useEffect(() => {
    if (selectedClient) {
      setClientContacts(selectedClient.client_contacts)
    }
  }, [selectedClient])

  return (
    <Modal isOpen={openEditClient} onClose={() => browseState.toggleEditClient() }>
      <Modal.Header>Edit Client</Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            name: selectedClient.name || '',
            collaborators: selectedClient.collaborators || [],
            client_contacts: selectedClient.client_contacts || [],
            theme_color: selectedClient.theme_color || '',
            image: selectedClient.avatar || '',
          }}
          enableReinitialize
          validationSchema={ClientSchema}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, handleBlur, handleChange, values, touched, errors }) => (
              <Form className="w-[475px]">
                    <PageToRender
                      setFieldValue={setFieldValue}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      values={values}
                      touched={touched}
                      errors={errors}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      {...specificProps}
                    />
              </Form>
            )
          }
        </Formik>
      </Modal.Body>
    </Modal>
  )
})
